export default "__VITE_ASSET__ByK8pREf__"